import type { ReactNode } from "react";
import { useMe } from "@/context/me";
import { isDealerWithoutRole } from "./isDealerWithoutRole";

type DenyDealerWithoutRoleProps = {
  children: ReactNode;
  fallback: ReactNode;
};

/** Blocks account routes when the dealer has no role and no permissions. */
export function DenyDealerWithoutRole(props: DenyDealerWithoutRoleProps) {
  const { children, fallback } = props;
  const { me } = useMe();

  if (isDealerWithoutRole(me.role, me.permissionList)) {
    return fallback;
  }

  return children;
}
